import { Spec } from "swagger-schema-official";

import * as _ from "lodash";


export const Triggers: { [trigger: string]: { displayName: string, triggerType: string } } = {
    ManualTrigger: { displayName: "Manual", triggerType: "ManualTrigger" },
    FileWatchTrigger: { displayName: "File", triggerType: "FileWatchTrigger" },
    ScheduleTrigger: { displayName: "Schedule", triggerType: "ScheduleTrigger" },
    ConditionalTrigger: { displayName: "Conditional", triggerType: "ConditionalTrigger" },
    HttpTrigger: { displayName: "HTTP", triggerType: "HttpTrigger" },
    HttpApiTrigger: { displayName: "API", triggerType: "HttpApiTrigger" },
    QueueTrigger: { displayName: "Queue", triggerType: "QueueTrigger" },
    ServiceBusTrigger: { displayName: "Service Bus", triggerType: "ServiceBusTrigger" },
    RabbitMQTrigger: { displayName: "RabbitMQ", triggerType: "RabbitMQTrigger" },
    TcpTrigger: { displayName: "TCP", triggerType: "TcpTrigger" },
};

export interface IScheduleParameters {
    startTimeMinute: string;
    startTimeHour: string;
    endTimeMinute: string;
    endTimeHour: string;
    endTime: string;
    startTime: string;
    recurring: boolean;
    repeatDelay: number;
    repeatDelaySeconds: number;
    limitToOneConcurrentExecution: boolean;
    cycleRecurEvery: number;
    cycleType: ScheduleCycleType;
    cycleLength: number;
    seasonStartDate: string;
    seasonEndDate?: string | null;
    cycleDaysOfWeek: string;
    cycleMonths: string;
    cycleDaysString: string;
    cycleDayRanks: string;
    monthlyCycleType: MonthlyCycleType;
    repeatDelayType: 1 | 60 | 3600;
    timeZone: string | undefined;
    datesToExclude?: string;
    openOnlyOnDates?: string;
}

export enum ScheduleCycleType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly"
}

export enum MonthlyCycleType {
    OnDays = "OnDays",
    BasedOnDayOrder = "BasedOnDayOrder"
}

export interface IValueLabel {
    value: any;
    label: string;
}

export const RepeatDelayType: IValueLabel[] = [
    { value: 1, label: FRENDS.Localizations.Seconds },
    { value: 60, label: FRENDS.Localizations.Minutes },
    { value: 3600, label: FRENDS.Localizations.Hours }
];
export const CycleType: IValueLabel[] = [
    { value: "Daily", label: FRENDS.Localizations.Daily },
    { value: "Weekly", label: FRENDS.Localizations.Weekly },
    { value: "Monthly", label: FRENDS.Localizations.Monthly }
];
export const WeekDays: IValueLabel[] = [
    { value: "Monday", label: FRENDS.Localizations.Monday },
    { value: "Tuesday", label: FRENDS.Localizations.Tuesday },
    { value: "Wednesday", label: FRENDS.Localizations.Wednesday },
    { value: "Thursday", label: FRENDS.Localizations.Thursday },
    { value: "Friday", label: FRENDS.Localizations.Friday },
    { value: "Saturday", label: FRENDS.Localizations.Saturday },
    { value: "Sunday", label: FRENDS.Localizations.Sunday }
];

export const ExtendedWeekDays: IValueLabel[] =
    WeekDays.concat([
        { value: "weekDay", label: FRENDS.Localizations.weekday },
        { value: "weekendDay", label: FRENDS.Localizations.weekendDay }
    ]);

export const CycleMonths: IValueLabel[] = [
    { value: "January", label: FRENDS.Localizations.January },
    { value: "February", label: FRENDS.Localizations.February },
    { value: "March", label: FRENDS.Localizations.March },
    { value: "April", label: FRENDS.Localizations.April },
    { value: "May", label: FRENDS.Localizations.May },
    { value: "June", label: FRENDS.Localizations.June },
    { value: "July", label: FRENDS.Localizations.July },
    { value: "August", label: FRENDS.Localizations.August },
    { value: "September", label: FRENDS.Localizations.September },
    { value: "October", label: FRENDS.Localizations.October },
    { value: "November", label: FRENDS.Localizations.November },
    { value: "December", label: FRENDS.Localizations.December }
];

export const CycleMonthRanks: IValueLabel[] = [
    { value: "First", label: FRENDS.Localizations.First },
    { value: "Second", label: FRENDS.Localizations.Second },
    { value: "Third", label: FRENDS.Localizations.Third },
    { value: "Fourth", label: FRENDS.Localizations.Fourth },
    { value: "Last", label: FRENDS.Localizations.Last }
];

export const CycleMonthDays: IValueLabel[] =
    _.range(1, 31, 1)
        .map((i) => ({ value: i.toString(), label: i.toString() } as IValueLabel))
        .concat({ value: "Last", label: FRENDS.Localizations.Last });

export const CycleMonthType: IValueLabel[] = [
    { value: "OnDays", label: FRENDS.Localizations.OnDays },
    { value: "BasedOnDayOrder", label: FRENDS.Localizations.BasedOnDayOrder }
];
export interface ITimeZoneEntry {
    ianaNames: string[];
    id: string;
    label: string;
}

export interface IHttpTrigger {
    routeTemplate: string;
    allowedSchemes: string;
    auth: string;
    corsEnabled: boolean;
    allowedOrigins: string;
    httpMethod: string;
    isPrivate: boolean;
}

export interface IQueueTriggerBaseConfig {
    reply?: boolean;
    replyErrors?: boolean;
    replyTo?: string;
    queueName?: string;
}

export interface IHttpApiTrigger extends IHttpTrigger {
    apiSpec: Spec | null;
}

export interface ICheckBoxViewModel {
    label: string;
    value: string;
    selected: boolean;
}

export interface FileWatchTriggerConfig {
    version: number;
    dirToWatch: string;
    fileMask: string;
    includeSubDirectories: boolean;
    maxFilesPerBatch: number;
    pollIntervalSeconds: number;
    quietPeriodSeconds?: number;
    username?: string;
    password?: string;
}

export interface FileWatchTriggerConfigV1 {
    dirToWatch: string;
    fileMask: string;
    includeSubDirectories?: boolean;
    batchTriggerEvents?: boolean;
    username?: string;
    password?: string;
}

export interface ConditionalTriggerConfig {
    pollingInterval: number;
    processGuid: string;
    limitToOneConcurrentExecution?: boolean;
}

export interface ManualTriggerConfig {
    [defaultValue: string]: string;
}
